import { Link } from "react-router-dom";
import "./DashboardV3.css";

export default function DashboardV3(): JSX.Element {
  const supporters = [
    { name: "James Lockwood", started: "Jun '23", monthly: 250, total: 9000, tier: "Architect" },
    { name: "Helena Voss",    started: "Dec '23", monthly: 100, total: 3000, tier: "Founder" },
    { name: "M.J. Asante",    started: "Apr '24", monthly:  50, total: 1300, tier: "Benefactor" },
    { name: "Dr. Owen Hayes", started: "May '25", monthly:  25, total:  325, tier: "Patron" },
    { name: "Camille Joubert",started: "Jun '25", monthly:  25, total:  300, tier: "Patron" },
    { name: "Hiro Tanaka",    started: "Aug '25", monthly:  10, total:  100, tier: "Member" },
    { name: "Lena R.",        started: "Aug '25", monthly:  10, total:  100, tier: "Member" },
    { name: "Sarah K.",       started: "Sep '25", monthly:   5, total:   45, tier: "Supporter" },
    { name: "Marcus T.",      started: "Sep '25", monthly:   5, total:   45, tier: "Supporter" },
    { name: "Priya N.",       started: "Oct '25", monthly:   5, total:   40, tier: "Supporter" },
  ];
  const mrr = supporters.reduce((s, x) => s + x.monthly, 0);
  const fee = Math.round(mrr * 0.049);
  const takeHome = mrr - fee;
  const totalLifetime = supporters.reduce((s, x) => s + x.total, 0);

  return (
    <div className="gl-page dbg3">
      <aside className="dbg3-side">
        <Link to="/" className="dbg3-brand">
          <span className="dbg3-brand-glyph"></span> SubsWall
        </Link>
        <nav>
          <a className="dbg3-nav-link dbg3-active">⌂ Home</a>
          <a className="dbg3-nav-link">⌽ Supporters <span>{supporters.length}</span></a>
          <a className="dbg3-nav-link">$ Earnings</a>
          <a className="dbg3-nav-link">⌜ Wall settings</a>
          <a className="dbg3-nav-link">⇲ Payouts</a>
          <a className="dbg3-nav-link">&lt;/&gt; Embed</a>
          <div className="dbg3-divider"></div>
          <a className="dbg3-nav-link">⚙ Account</a>
          <a className="dbg3-nav-link">→ Sign out</a>
        </nav>
        <Link to="/demo" className="dbg3-side-foot">View public wall ↗</Link>
      </aside>

      <main className="dbg3-main">
        <header className="dbg3-head">
          <div>
            <div className="gl-eyebrow">Welcome back, Demo</div>
            <h1 className="gl-display dbg3-h1">Your wall.</h1>
          </div>
          <Link to="/demo" className="gl-btn gl-btn-ghost">Open public wall →</Link>
        </header>

        <section className="dbg3-kpis">
          <div className="gl-card dbg3-kpi">
            <div className="gl-eyebrow">Monthly recurring</div>
            <div className="gl-mono dbg3-kpi-num">${mrr.toLocaleString()}</div>
            <div className="dbg3-kpi-sub">${takeHome.toLocaleString()} to you · ${fee} fee</div>
          </div>
          <div className="gl-card dbg3-kpi">
            <div className="gl-eyebrow">Supporters</div>
            <div className="gl-mono dbg3-kpi-num">{supporters.length}</div>
            <div className="dbg3-kpi-sub">+2 this month · 0 cancellations</div>
          </div>
          <div className="gl-card dbg3-kpi">
            <div className="gl-eyebrow">Lifetime contributed</div>
            <div className="gl-mono dbg3-kpi-num">${totalLifetime.toLocaleString()}</div>
            <div className="dbg3-kpi-sub">Across all supporters</div>
          </div>
          <div className="gl-card-accent dbg3-kpi dbg3-kpi-gold">
            <div className="gl-eyebrow">Next payout</div>
            <div className="gl-mono dbg3-kpi-num">${takeHome.toLocaleString()}</div>
            <div className="dbg3-kpi-sub">Stripe · 1st of next month</div>
          </div>
        </section>

        <section className="dbg3-section">
          <div className="dbg3-section-head">
            <h2 className="gl-display dbg3-h2">Your supporters</h2>
            <div className="dbg3-tools">
              <input type="search" placeholder="Search…" />
              <button className="gl-btn gl-btn-ghost gl-btn-sm">Export CSV</button>
            </div>
          </div>
          <div className="dbg3-table-wrap">
            <table className="dbg3-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Since</th>
                  <th className="dbg3-num">Monthly</th>
                  <th className="dbg3-num">Lifetime</th>
                  <th>Tier</th>
                </tr>
              </thead>
              <tbody>
                {supporters.map((s) => (
                  <tr key={s.name}>
                    <td>{s.name}</td>
                    <td className="dbg3-mute gl-mono">{s.started}</td>
                    <td className="dbg3-num gl-mono">${s.monthly}</td>
                    <td className="dbg3-num gl-mono">${s.total.toLocaleString()}</td>
                    <td><span className={`dbg3-tier dbg3-t-${s.tier.toLowerCase()}`}>{s.tier}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        <section className="dbg3-section">
          <div className="dbg3-section-head">
            <h2 className="gl-display dbg3-h2">Embed your wall</h2>
          </div>
          <p className="gl-lead dbg3-embed-copy">
            Paste anywhere — YouTube About page, video descriptions, your own
            site. The wall updates live as new supporters sign on.
          </p>
          <pre className="dbg3-code gl-mono">{`<iframe src="https://subswall.com/demo/embed"
        width="100%" height="600"
        style="border:0;border-radius:14px;"
        loading="lazy"></iframe>`}</pre>
        </section>
      </main>
    </div>
  );
}
